import React from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Col, FormFeedback, Button } from 'reactstrap';
import Select from 'react-select';
import 'react-select/dist/react-select.css';

const FormControlSelect = ({
  autoBlur,
  children,
  clearable,
  fieldRemovable,
  id,
  input,
  label,
  meta: { touched, error },
  multi,
}) => {
  let validationState = null;
  let errorText = null;

  if (touched) {
    if (error) {
      validationState = 'danger';
      errorText = error;
    } else {
      validationState = 'success';
    }
  }

  let optionChildren = children;
  if (children && !{}.hasOwnProperty.call(children, 'length')) {
    optionChildren = [children];
  }

  const options =
    optionChildren &&
    optionChildren.map(child => ({
      value: child.props.value,
      label: child.props.children,
    }));

  const onChange = multi
    ? values => input.onChange(values.map(val => val.value))
    : val => input.onChange(val ? val.value : val);

  return (
    <FormGroup row color={validationState} className="form-group-2col">
      <Label for={id} sm={3} xs={12}>
        {label}
      </Label>
      <Col sm={8} md={6} xs={12}>
        <Select
          {...input}
          autoBlur={autoBlur}
          multi={multi}
          clearable={clearable}
          options={options}
          onChange={onChange}
          onBlur={() => input.onBlur(input.value)}
        />
        <FormFeedback>{errorText}</FormFeedback>
      </Col>
      {fieldRemovable && (
        <Col sm="1" className="d-none d-md-block">
          <Button className="ml-auto" color="link" onClick={fieldRemovable}>
            <i className="icon-trash-o" aria-hidden="true" />
          </Button>
        </Col>
      )}
    </FormGroup>
  );
};

FormControlSelect.propTypes = {
  autoBlur: PropTypes.bool,
  children: PropTypes.node,
  clearable: PropTypes.bool,
  fieldRemovable: PropTypes.func,
  id: PropTypes.string,
  input: PropTypes.shape({}),
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  meta: PropTypes.shape({}),
  multi: PropTypes.bool,
};

FormControlSelect.defaultProps = {
  autoBlur: false,
  multi: false,
  clearable: false,
};

export default FormControlSelect;
